import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServiceFormComponent } from './service-form/service-form.component';
import { ServiceViewComponent } from './service-view/service-view.component';
import { ServiceRoutingModule } from './service-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [
    ServiceFormComponent,
    ServiceViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    ServiceRoutingModule
  ]
})
export class ServiceModule {
  title: 'Service Master';
}
